/*-- import aliases -----------
'!/...' -> project root
'~/...' -> vue folder root
'@/...' -> src folder root
-----------------------------*/

import { createApp } from 'vue';
import { createPinia } from 'pinia';
import App from '@/market-data/App.vue';
import Blue from '../js/core';


new Blue({
  name: 'Market Data',
  selector: '#market-data',
  setup(el) {
    const app = createApp(App, { ...el.dataset });
    const pinia = createPinia();
    app.use(pinia);
    app.mount(el);
  }
}, false);
